export default {
  autoDismiss: 3,
  position: "tr",
  uid: 1,
};
